export const VOTING_CATEGORY = {
  NATIONAL: 'National',
  REGIONAL: 'Regional',
  GLOBAL: 'Global'
}

export const VOTING_CATEGORY_SETTINGS_BY_VOTING_CATEGORY = {
  [VOTING_CATEGORY.NATIONAL]: {
    title: 'vote national',
    value: VOTING_CATEGORY.NATIONAL,
    className: 'national'
  },
  [VOTING_CATEGORY.REGIONAL]: {
    title: 'vote regional',
    value: VOTING_CATEGORY.REGIONAL,
    className: 'regional'
  },
  [VOTING_CATEGORY.GLOBAL]: {
    title: 'vote global',
    value: VOTING_CATEGORY.GLOBAL,
    className: 'global'
  }
}

export const VOTING_STATUS = {
  NONE: 'None',
  AVAILABLE: 'Available',
  SUBMITTED: 'Submitted'
}

export const CATEGORIES_MODEL = {
  National: {
    VotingStatus: VOTING_STATUS.NONE,
    Nominations: []
  },
  Regional: {
    VotingStatus: VOTING_STATUS.NONE,
    Nominations: []
  },
  Global: {
    VotingStatus: VOTING_STATUS.NONE,
    Nominations: []
  }
}

export const VOTE_DATA_STORAGE_KEY = 'vdsk'

export const VOTING_CATEGORY_TYPE = {
  B2B: 'B2B',
  B2C: 'B2C'
}

export const VOTING_CATEGORY_TITLE_DATA_BY_CATEGORY_TYPE = {
  [VOTING_CATEGORY_TYPE.B2C]: {
    title: 'B2C brokerage brands',
    subtitle: 'Brokerage Brand'
  },
  [VOTING_CATEGORY_TYPE.B2B]: {
    title: 'B2b fintech brands ',
    subtitle: 'Fintech Brand'
  }
}
